<div class="SLV2-main-wrapper scroll" (scroll)="divScroll($event)" >

    <!-- <div class="col-xl-2 col-md-3">
        <app-sidebar-learn></app-sidebar-learn>
    </div> -->

    <div class="col-xl-2 col-md-3" *ngIf="selfLearnService.isFromLearn()">
        <app-sidebar-learn></app-sidebar-learn>    
    </div>

    <div class="SLV2-body-section">

        <div class="SLV2-section-wrap SLV2-page-header-area">
            <div class="row SLV2-sm-gap">
                <div class="col">
                    <button class="SLV2-header-text-button SLV2-library" (click)="navigateToMylibrary()">
                        <img src="selflearnv2-ui/assets/img/self-learn-v2/banner-back-arrow.svg" />
                        <span>Bookmarks</span>
                    </button>
                </div>
            </div>
        </div>


        <div class="SLV2-bookmrk-filter-area">
            <ul>
                <li>
                    <label class="SLV2-bookmrk-filter-btn" (click)="openBookmarkSubjectDialog()"  [ngClass]="popSubjectSelected?.length >1 ? 'check-subjects': ''">
                        <span> {{ selectedSubjectName?.nodeName  ? popSubjectSelected?.length > 1? (popSubjectSelected?.length) +' Subjects': selectedSubjectName?.nodeName:'All Subjects'}} <img src="selflearnv2-ui/assets/img/self-learn-v2/down-arrow-black-icon.svg" class="arrow" /> </span>
                    </label>
                </li>
                <li>
                    <label class="SLV2-bookmrk-filter-btn" >
                        <input type="checkbox" class="input" name="Bookmark-filter" (click)="changeFilter($event,'video')" />
                        <span>Videos</span>
                    </label>
                </li>
                <li>
                    <label class="SLV2-bookmrk-filter-btn">
                        <input type="checkbox" class="input" name="Bookmark-filter"  (click)="changeFilter($event,'flashcard')"/>
                        <span>Topic summary</span>
                    </label>
                </li>
                <!-- <li>
                    <label class="SLV2-bookmrk-filter-btn" >
                        <input type="checkbox" class="input" name="Bookmark-filter" (click)="changeFilter($event,'practice_question')" />
                        <span>Questions</span>
                    </label>
                </li> -->
                <li >
                    <label class="SLV2-bookmrk-filter-btn" >
                        <input type="checkbox" class="input" name="Bookmark-filter" (click)="changeFilter($event,'memory_card')"/>
                        <span>Memory cards</span>
                    </label>
                </li>
            </ul>
        </div>





        <div class="SLV2-section-wrap" >
            <div class="row SLV2-sm-gap">
               <div class="col">
                   <div class="SLV2-section-head-section">
                       <h3 class="SLV2-section-heading">Recently Bookmarked</h3>
                       <!-- <button class="SLV2-viewall-link">View all <img src="selflearnv2-ui/assets/img/self-learn-v2/right-blue-arrow.svg" /></button> -->
                    </div>
                </div>
            </div>
            <div class="row SLV2-sm-gap SLV2-leading-zero-list">
                <div class="col-md-3 bookmarks-col" *ngFor="let item of allBookMarksList">
               
                    <app-bookmark-video-card class="mobile-col-view" *ngIf="item.type == 'video' || item.type =='video_solution'" [videoData]="item" [cardTitle]="item.name" [isFromMyLibrary]=false [isFromMyHistory]=false></app-bookmark-video-card>
                    <app-bookmark-topic-summery-card class="mobile-col-view" *ngIf="item.type == 'flashcard'" [topicName]="item?.name" [flashcardData]="item" [allTopicsSummeryProgress]="allTopicsSummeryProgress" [isFromMyLibrary]=false [isFromMyHistory]=false></app-bookmark-topic-summery-card>
                    <app-memory-thumb-card class="mobile-col-view " *ngIf="item.type == 'memory_card'" [memoryData]="item" [cardTitle]="item.name" [isFromMyLibrary]=false [isFromMyHistory]=false></app-memory-thumb-card>
                    <app-questions-thumb-card class="mobile-col-view" *ngIf="item.type == 'practice_question'" [questionData]="item" [cardTitle]="item.name" [isFromMyLibrary]=false [isFromMyHistory]=false></app-questions-thumb-card> 
                </div>
            </div>
        </div>
        
    </div>
</div>
<div class="row SLV2-sm-gap" *ngIf="allBookMarksList.length <= 0">
    <div class="col">
        <div class="SLV-no-content-box">
            <img src="selflearnv2-ui/assets/img/self-learn-v2/no-bookmark-frame.svg" class="no-content-avatar" />
            <h3 class="no-content-hdng">Uh uh! No bookmark found</h3>
            <h4 class="no-content-text">Start exploring and save your <br> favorites for easy access.</h4>
        </div>
    </div>
</div>
